import ApiService from "@/services/api.service";

const route = 'reports';

import Vue from 'vue';

const reports = {
    afterSales(_params) {
        return new Promise((resolve, reject) => {
            console.log('_params ', _params)
            var params = "?created_init_at=" + Vue.moment(_params.created_at[0]).format('YYYY-MM-DD');
            params += "&created_end_at=" + Vue.moment(_params.created_at[1]).format("YYYY-MM-DD");
            params += "&branch_id=" + _params.branch_id;
            params += "&representative_id=" + _params.representative_id;
            params += "&status_id=" + _params.status_id;
            params += "&team_id=" + _params.team_id;
            params += "&situation=" + _params.situation;

            ApiService.get(route, "after-sales" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    contracts(_params) {
        return new Promise((resolve, reject) => {
            console.log('_params ', _params)
            var params = "?created_init_at=" + Vue.moment(_params.created_at[0]).format('YYYY-MM-DD');
            params += "&created_end_at=" + Vue.moment(_params.created_at[1]).format("YYYY-MM-DD");
            params += "&branch_id=" + _params.branch_id;
            params += "&representative_id=" + _params.representative_id;
            params += "&status_id=" + _params.status_id;
            params += "&team_id=" + _params.team_id;
            params += "&situation=" + _params.situation;
            params += "&date_by=" + _params.date_by;

            ApiService.get(route, "contracts" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    commissionByProfilesDownloadInPdf(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&date_by=" + _params.date_by;
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            params += "&pdf=1"
            var profiles = _params.type_profile_id;

            profiles.forEach(function (_profile, _key) {
                params += "&type_profile_id[]=" + _profile.id
            });

            ApiService.download(route, "commission-by-profiles/download" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    commissionSurplusPerInstallment(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&date_by=" + _params.date_by;
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            params += "&salesman_id=" + _params.salesman_id;
            params += "&installment=" + _params.installment;

            var profiles = _params.type_profile_id;

            profiles.forEach(function (_profile, _key) {
                params += "&type_profile_id[]=" + _profile.id
            });

            ApiService.get(route, "surplus-per-installments" + params).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            })
        });
    },
    commissionSurplusPerInstallmentDownloadInPdf(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&date_by=" + _params.date_by;
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            params += "&salesman_id=" + _params.salesman_id;
            params += "&installment=" + _params.installment;
            params += "&pdf=1"

            var profiles = _params.type_profile_id;

            profiles.forEach(function (_profile, _key) {
                params += "&type_profile_id[]=" + _profile.id
            });

            ApiService.download(route, "surplus-per-installments/download" + params).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            })
        });
    },
    commissionContemplation(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            params += "&salesman_id=" + _params.salesman_id;

            ApiService.get(route, "contemplation" + params).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            })
        });
    },
    commissionContemplationInPdf(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            params += "&salesman_id=" + _params.salesman_id;
            params += "&pdf=1";

            ApiService.download(route, "contemplation/download" + params).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            })
        });
    },
    commissionBilling(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            params += "&salesman_id=" + _params.salesman_id;

            ApiService.get(route, "billing" + params).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            })
        });
    },
    commissionBillingInPdf(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            params += "&salesman_id=" + _params.salesman_id;
            params += "&pdf=1";

            ApiService.download(route, "billing/download" + params).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            })
        });
    },
    analyticalCommissionByProfiles(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&date_by=" + _params.date_by;
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            params += "&salesman_id=" + _params.salesman_id;
            params += "&profile_id=" + _params.profile_id;
            var profiles = _params.type_profile_id;

            profiles.forEach(function (_profile, _key) {
                params += "&type_profile_id[]=" + _profile.id
            });

            ApiService.get(route, "commission-by-profiles/analytical" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    analyticalCommissionByProfilesDownloadInPdf(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&date_by=" + _params.date_by;
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            params += "&salesman_id=" + _params.salesman_id;
            params += "&profile_id=" + _params.profile_id;
            params += "&pdf=1"
            var profiles = _params.type_profile_id;

            profiles.forEach(function (_profile, _key) {
                params += "&type_profile_id[]=" + _profile.id
            });

            ApiService.download(route, "commission-by-profiles/analytical/download" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    leadConversion(_params) {
        return new Promise((resolve, reject) => {
            var params = '';

            if(_params.sale_at[0]) {
                params = "?sale_start_at=" + Vue.moment(_params.sale_at[0]).format('YYYY-MM-DD');
                params += "&sale_end_at=" + Vue.moment(_params.sale_at[1]).format("YYYY-MM-DD");
            }
            if(_params.date_at[0]){

                if(params != '') {
                    params+='&';
                } else {
                    params+='?';
                }

                params += "date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
                params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            }
            if(_params.date_by){

                if(params != '') {
                    params+='&';
                } else {
                    params+='?';
                }
                params += "date_by=" + _params.date_by;
            }
            if(_params.administrator_id) {

                if(params != '') {
                    params+='&';
                } else {
                    params+='?';
                }

                params += "administrator_id=" + _params.administrator_id;
            }
            if(_params.team_id) {

                if(params != '') {
                    params+='&';
                } else {
                    params+='?';
                }
                params += "team_id=" + _params.team_id;
            }
            if(_params.responsible_id) {

                if(params != '') {
                    params+='&';
                } else {
                    params+='?';
                }

                params += "responsible_id=" + _params.responsible_id;
            }
            if(_params.branche_id) {

                if(params != '') {
                    params+='&';
                } else {
                    params+='?';
                }

                params += "branche_id=" + _params.branche_id;
            }

            ApiService.get(route, "lead-conversion" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },

    nonPaymentCancellation(_params) {
        return new Promise((resolve, reject) => {
            console.log('_params ', _params)


            var params = "?start_at=" + Vue.moment(_params.interval[0]).format('YYYY-MM-DD');
            params += "&end_at=" + Vue.moment(_params.interval[1]).format("YYYY-MM-DD");
            params += "&date_filter=" + _params.date_filter;


            if(_params.report_type) {
                params += "&report_type=" + _params.report_type;
            }

            if(_params.administrator_id) {
                params += "&administrator_id=" + _params.administrator_id;
            }

            if(_params.branche_id) {
                params += "&branche_id=" + _params.branche_id;
            }

            if(_params.salesman_id) {
                params += "&salesman_id=" + _params.salesman_id;
            }

            ApiService.get(route, "non-payment-cancellation" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    nonPaymentDelay(_params) {
        return new Promise((resolve, reject) => {
            console.log('_params ', _params.due_at)


            var params = "?due_start_at=" + Vue.moment(_params.due_at[0]).format('YYYY-MM-DD');
            params += "&due_end_at=" + Vue.moment(_params.due_at[1]).format("YYYY-MM-DD");

            if(_params.report_type) {
                params += "&report_type=" + _params.report_type;
            }

            if(_params.installments_order) {
                params += "&installments_order=" + _params.installments_order;
            }
            if(_params.administrator_id) {
                params += "&administrator_id=" + _params.administrator_id;
            }

            if(_params.branche_id) {
                params += "&branche_id=" + _params.branche_id;
            }

            if(_params.salesman_id) {
                params += "&salesman_id=" + _params.salesman_id;
            }

            ApiService.get(route, "non-payment-delay" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    nonPaymentMontly(_params) {
        return new Promise((resolve, reject) => {
            var params = "";
            console.log('_params ', _params)
            if(_params.interval[0]) {
                params = "?start_at=" + Vue.moment(_params.interval[0]).format('YYYY-MM-DD');
                params += "&end_at=" + Vue.moment(_params.interval[1]).format("YYYY-MM-DD");
                params += "&date_filter=" + _params.date_filter;
            }

            if(_params.administrator_id) {
                if(params.length > 1) {
                     params+="&";
                 } else {
                     params+="?";
                 }
                params += "administrator_id=" + _params.administrator_id;
            }

            if(_params.salesman_id) {
                if(params.length > 1) {
                    params+="&";
                } else {
                    params+="?";
                }
                params += "salesman_id=" + _params.salesman_id;
            }

            if(_params.installments_order) {
                if(params.length > 1) {
                     params+="&";
                 } else {
                     params+="?";
                 }
                params += "installments_order=" + _params.installments_order;
            }

            if(_params.branche_id) {

                if(params.length > 1) {
                    params+="&";
                } else {
                    params+="?";
                }
                params += "branche_id=" + _params.branche_id;
            }

            ApiService.get(route, "non-payment-montly" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    mediaConversion(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");

            if(_params.date_by){
                params += "&date_by=" + _params.date_by;
            }
            if(_params.administrator_id) {
                params += "&type_profile_id=" + _params.type_profile_id;
            }
            if(_params.team_id) {
                params += "&team_id=" + _params.team_id;
            }
            if(_params.responsible_id) {
                params += "&responsible_id=" + _params.responsible_id;
            }
            if(_params.branche_id) {
                params += "&branche_id=" + _params.branche_id;
            }

            ApiService.get(route, "media-conversion" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    evaluations(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");

            if(_params.team_id) {
                params += "&team_id=" + _params.team_id;
            }

            ApiService.get(route, "evaluations" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    commissionByProfiles(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&date_by=" + _params.date_by;
            params += "&administrator_id=" + _params.administrator_id;
            params += "&team_id=" + _params.team_id;
            var profiles = _params.type_profile_id;

            profiles.forEach(function (_profile, _key) {
                params += "&type_profile_id[]=" + _profile.id
            });

            ApiService.get(route, "commission-by-profiles" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    commissionOfProductionByProposalTypes(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + _params.administrator_id;
            params += "&type=" + _params.type;

            ApiService.get(route, "commission-of-production-by-proposal-types" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            })
        });
    },
    commissionOfProductionByProposalTypesDownloadInPdf(_params) {
        const filters = _params.filters;
        const data = _params.data;
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(filters.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(filters.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + filters.administrator_id;
            params += "&type=" + filters.type;
            params += "&pdf=1"

            Vue.axios.post(route + "/commission-of-production-by-proposal-types/download" + params, data, {responseType: 'arraybuffer'}).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    commissionOfMonths(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + _params.administrator_id;
            params += "&proposal_status_id=" + _params.proposal_status_id;

            ApiService.get(route, "commission-of-months" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            })
        });
    },
    commissionOfMonthsDownloadInPdf(_params) {
        const filters = _params.filters;
        const data = _params.data;
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(filters.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(filters.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + filters.administrator_id;
            params += "&proposal_status_id=" + filters.proposal_status_id;
            params += "&date_type=" + filters.date_type;
            params += "&type=" + filters.type;
            params += "&pdf=1"

            Vue.axios.post(route + "/commission-of-months/download" + params, data, {responseType: 'arraybuffer'}).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    storeCommission(_params){
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + (_params.administrator_id || '');
            params += "&installment=" + (_params.installment || '');
            params += "&reference=" + (_params.reference || '');
            params += "&branche_id=" + (_params.branche_id || '');

            // console.log(params)
            ApiService.get(route, "store-commission" + params).then(({ data }) => {
                resolve(data);
            }, error => {
                reject(error);
            })
        });
    },
    storeCommissionDetails(_params){
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&administrator_id=" + (_params.administrator_id || '');
            params += "&installment=" + (_params.installment || '');
            params += "&reference=" + (_params.reference || '');
            params += "&branche_id=" + (_params.branche_id || '');

            ApiService.get(route, "store-commission-details" + params).then(({ data }) => {
                resolve(data);
            }, error => {
                reject(error);
            })
        });
    },
    productionRating(_params){
        return new Promise((resolve, reject) => {
            let query = Object.keys(_params.interval).map(key => {
                            return encodeURIComponent(key) + '=' + encodeURIComponent(_params.interval[key]);
                        }).join('&');
            let params = "?reference=" + _params.reference;
            params += '&'+query;

            ApiService.get(route, "production-rating" + params).then(({ data }) => {
                resolve(data);
            }, error => {
                reject(error);
            })
        });
    },
    typeSalesByProfile(_params) {
        return new Promise((resolve, reject) => {
            console.log(_params);
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&date_by=" + _params.date_by;
            params += "&branch_id=" + _params.branch_id;
            params += "&administrator_id=" + _params.administrator_id;
            params += "&type_profile_id=" + _params.type_profile_id;
            params += "&user_id=" + (_params.user_id && _params.user_id.id ? _params.user_id.id : null);

            ApiService.get(route, "type-sales" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    typeSalesByProfileInPdf(_params) {
        return new Promise((resolve, reject) => {
            var params = "?date_init_at=" + Vue.moment(_params.date_at[0]).format('YYYY-MM-DD');
            params += "&date_end_at=" + Vue.moment(_params.date_at[1]).format("YYYY-MM-DD");
            params += "&date_by=" + _params.date_by;
            params += "&branch_id=" + _params.branch_id;
            params += "&administrator_id=" + _params.administrator_id;
            params += "&type_profile_id=" + _params.type_profile_id;
            params += "&user_id=" + (_params.user_id && _params.user_id.id ? _params.user_id.id : null);
            params += "&date_by=" + _params.date_by;
            params += "&pdf=1"

            ApiService.download(route, "type-sales" + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
};

export default reports;
